import { AnyAction, Reducer } from 'redux';
import {
  GlobalAction,
  GlobalActions,
  isAzam,
  ProduktDeleted,
  ReplaceState,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import cloneDeep from 'lodash/cloneDeep';
import { Zahlungsart } from '@ps20/bff-models';
import {
  migrateAktionsnachlassAktion10, migrateAngebotsdatum,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { INITIAL_STATE } from '../initialState';
import { loadAndMigrateJhpState } from '../migrations';

export const rootReducer =
  (reducer: Reducer) =>
  (state: IAppState, action: AnyAction): IAppState => {
    switch (action.type) {
      case GlobalActions.REPLACE_STATE: {
        const actionPayload: ReplaceState<IAppState> = action.payload;
        if (actionPayload.appId === App.JHP) {
          return actionPayload.appState;
        }
        return state;
      }
      case GlobalActions.PRODUKT_DELETED: {
        const actionPayload: ProduktDeleted = action.payload;
        if (actionPayload.angebotsIds.some(angebot => angebot.appId === App.JHP)) {
          return {
            ...state,
            versicherungsnehmer: {
              ...INITIAL_STATE.versicherungsnehmer,
              geburtsdatum: state.versicherungsnehmer.geburtsdatum,
              isAssekuranztarif: state.versicherungsnehmer.isAssekuranztarif,
              adresse: state.versicherungsnehmer.adresse,
            },
            vertragsoptionen: {
              ...INITIAL_STATE.vertragsoptionen,
              zahlungsart: state.vertragsoptionen.zahlungsart,
              zahlungsweise: state.vertragsoptionen.zahlungsweise,
            },
          };
        }
        return state;
      }
      case GlobalActions.SAVED_STATES_LOADED: {
        const newState = cloneDeep(state);
        const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
          .payload.savedStatesLoaded;
        const loadedAppState = actionPayload.find(loadedState => loadedState.appId === App.JHP);
        if (loadedAppState != null) {
          if (
            isAzam(newState.transientState.role) &&
            newState.vertragsoptionen?.zahlungsart === Zahlungsart.MAKLER_INKASSO
          ) {
            delete loadedAppState.state.vertragsoptionen.zahlungsart;
          }
          migrateAngebotsdatum(loadedAppState.state);
          migrateAktionsnachlassAktion10(
            loadedAppState.state,
            newState.transientState.featureToggles,
          );
          return loadAndMigrateJhpState(
            newState,
            loadedAppState.state,
            loadedAppState.state.vertragsoptionen?.beibehalten,
          );
        } else {
          return state;
        }
      }
      default:
        return reducer(state, action);
    }
  };
